import Header from "@/components/header/header";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import { useHelp } from "./help/useHelp";
import { PspTextArea } from "@/components/pspTextArea/pspTextArea";
import PspButton from "@/components/pspButton/PspButton";
import { translate } from "@/config/translator";
import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";

export default function Help() {
  const {
    body,
    email,
    isLoggedIn,
    setBody,
    setEmail,
    setSubject,
    subject,
    onSend,
    lang,
    navigate,
    canSend,
    isTablet,
  } = useHelp();
  return (
    <div className="h-screen">
      <TopBarMobile
        headerString={translate("needHelp", lang)}
        onBack={() => navigate(-1)}
      />
      <div className="flex flex-col items-center w-screen p-8">
        <Header text="contactUs" />
        <div className="desktop:w-1/3 tablet:w-1/2 w-full flex flex-col gap-4">
          {!isLoggedIn && (
            <PspTextInput label="email" value={email} onChange={setEmail} />
          )}
          <PspTextInput label="subject" value={subject} onChange={setSubject} />
          <PspTextArea
            rows={7}
            label="message"
            value={body}
            onChange={setBody}
          />

          <div className="w-full flex flex-row justify-end gap-2">
            {isTablet && (
              <PspButton onClick={() => navigate(-1)}>
                {translate("back", lang)}
              </PspButton>
            )}

            <PspButton
              appearance="primary"
              disabled={!canSend}
              onClick={onSend}
            >
              {translate("send", lang)}
            </PspButton>
          </div>
        </div>
      </div>
    </div>
  );
}
